// eslint-disable  prefer-arrow/prefer-arrow-functions
// eslint-disable-next-line no-shadow
export enum InsuranceType {
	AccidentIllness = `1`,
	AccidentOnly = `2`,
}

export function getInsuranceType(insuranceType: InsuranceType): string {
	switch (insuranceType) {
		case InsuranceType.AccidentOnly:
			return `Accident Only`;
		case InsuranceType.AccidentIllness:
		default:
			return `Accident & Illness`;
	}
}
